import classnames from 'classnames'

export interface INetworkSelector {
  selected: string
  chain: string
  onSelect: any
}

const NetworkSelector = ({ selected, chain, onSelect }: INetworkSelector) => {
  const mainNetwork = {
    text: 'Main net',
    value: 'mainnet',
  }

  const testNetwork = {
    text: chain === 'multiversx' ? 'Dev net' : 'Test net',
    value: 'testnet',
  }

  const networks = chain === 'multiversx' ? [mainNetwork, testNetwork] : [testNetwork]

  return (
    <div className="flex flex-row gap-4">
      {networks.map((network, key) => (
        <button
          className={classnames(
            'flex items-center rounded-lg border px-4 py-1 text-sm text-white',
            {
              '!text-main-blue': network.value === selected,
            },
          )}
          onClick={() => onSelect(network.value)}
          key={key}>
          <span className="capitalize">{network.text}</span>
        </button>
      ))}
    </div>
  )
}

export default NetworkSelector
